var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { WorkspaceDomainStatus } from '@lucidlink/dto/validation';
import { useAuthProvider, useLucidSdk } from '#context';
import { WorkspaceDomainsKeyFactory } from '../../../query-key-factories';
import { WORKSPACE_DOMAIN_LIST_POLLING_INTERVAL } from './constants';
export const useListWorkspaceDomains = (workspaceId, { enabled = true } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { currentUser } = useAuthProvider();
    const query = useQuery({
        queryKey: WorkspaceDomainsKeyFactory.byWorkspace(workspaceId),
        queryFn: () => lucidSdk.workspaceClient(workspaceId).domain().listDomains(),
        networkMode: 'always',
        refetchInterval: (query) => {
            if (!query.state.data) {
                return false;
            }
            const pendingDomains = query.state.data.filter((d) => d.verification.status === WorkspaceDomainStatus.PENDING);
            return pendingDomains.length > 0
                ? WORKSPACE_DOMAIN_LIST_POLLING_INTERVAL
                : false;
        },
        enabled: Boolean(currentUser?.emailVerified && enabled && workspaceId),
    });
    return { query };
};
_react_refresh_temp_1(useListWorkspaceDomains, "wEg9DMWQ/CI4rGOcHGIhupr8WvQ=", false, () => [useLucidSdk, useAuthProvider, useQuery]);
